import { array as isArray } from "is";

const pattern = /(\w+)\[(\d+)\]/;

/**
 * Safely encode the given string
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

const encode = function(str) {
  try {
    return encodeURIComponent(str);
  } catch (e) {
    return str;
  }
};

/**
 * Safely decode the string
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

const decode = function(str) {
  try {
    return decodeURIComponent(str.replace(/\+/g, " "));
  } catch (e) {
    return str;
  }
};

/**
 * Parse the given query `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api public
 */

export function parse(value) {
  if (typeof value != "string") {
    return {};
  }
  let str = value;

  str = str.replace(/^\s*|\s*$/g, "");
  if (str === "") {
    return {};
  }
  if (str.charAt(0) === "?") {
    str = str.slice(1);
  }

  const obj = {};
  const pairs = str.split("&");
  for (let i = 0; i < pairs.length; i++) {
    const parts = pairs[i].split("=");
    const key = decode(parts[0]);
    let m;

    if ((m = pattern.exec(key))) {
      obj[m[1]] = obj[m[1]] || [];
      obj[m[1]][m[2]] = decode(parts[1]);
      continue;
    }

    obj[parts[0]] = parts[1] == null ? "" : decode(parts[1]);
  }

  return obj;
}

/**
 * Stringify the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api public
 */

export function stringify(obj) {
  if (!obj) {
    return "";
  }
  const pairs = [];

  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    const value = obj[key];

    if (isArray(value)) {
      for (let i = 0; i < value.length; ++i) {
        pairs.push(`${encode(`${key}[${i}]`)}=${encode(value[i])}`);
      }
      continue;
    }

    pairs.push(`${encode(key)}=${encode(obj[key])}`);
  }

  return pairs.join("&");
}
